/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import { withRouter } from 'react-router';
import loadable from '@loadable/component';
import {
    object, shape, string, bool, array, func, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import track from 'react-tracking';
import Media from 'react-media';
import ReactHtmlParser from 'react-html-parser';
import Cookies from 'universal-cookie';

// Icons
import Star from '@material-ui/icons/Star';
import StarHalf from '@material-ui/icons/StarHalf';

import { withApollo } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import mbpUtil from 'mbp-api-util';

// gql & helper functions
import { GRAPHQL_ENV } from '../../../gql';
import memberDucks from '../../../../state/ducks/Member/ducks';
import * as app from '../../../../state/ducks/App';
import { trackPage, trackProductData } from '../../../helpers/tracking/common/commonTrackingHelpers';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getBaseCode } from '../../../helpers/tracking/product/dataLayerProductHelpers';
import clubQueries from '../../../gql/queries/findClubData';
import productPageQueries from '../../../gql/queries/findProductPageByPartNumber';
import findCategoryPageByURL from '../../../gql/queries/findCategoryPageByURL';
import { setAgeVerifyFlagInvalid, clearGCIData } from '../../../../state/ducks/App/App-Actions';
import {
    getAddressSource, getCurrencyData, getLocationType,
} from '../../../../state/ducks/App/App-Selectors';
import { getLanguageName } from '../../../../state/ducks/Member/ducks/Auth/helper/helper';
import brandThemes from '../../AppShell/brandtheme';
import DesktopMobile from '../../../helpers/DesktopMobile/DesktopMobile';
// Product Page UI components
import { addOgDynamicData, getBreadcrumbArray, dateStringReformat } from './Partials/common/commonProductPageHelper';
import GraphqlProductImageUI from './Partials/GraphqlProductImageUI';
import GraphqlProductImageUIMobile from './Partials/ProductImageUI/ProductImageUIMobile';
import GraphqlDeliveryMethodUI from './Partials/GraphqlDeliveryMethodUI';
import GraphqlProductDetailsTab from './Partials/GraphqlProductDetailsUI';
import GraphqlFoodProductDetailsTab from './Partials/GraphqlFoodDetailsUI/GraphqlFoodDetailsUI';
import GraphqlProductSeoSchema from './Partials/GraphqlProductSeoSchema/GraphqlProductSeoSchema';
import PDPSkeleton from '../GraphqlSkeletonComponents/PDPSkeleton';
import ProductListingAdCategoryContainer from './Partials/ProductListingAdCategoryContainer';
import GraphqlClubProductPage from './GraphqlClubProductPage';
import { ducks as checkoutDucks } from '../../../../state/ducks/Checkout';
import GraphqlPortalLoader from '../GraphqlCommonComponents/GraphqlPortalLoader';
import SiteLoader from '../../../pages/Checkout/containers/CheckoutFood/components/Partials/SiteLoader/SiteLoader';
import MiniCart from '../../../pages/Checkout/containers/CheckoutFood/components/Partials/MiniCart/MiniCart';
import GraphqlCYOProductPageBuilder from './Partials/GraphqlCustomProductPage/GraphqlCYOProductPage/GraphqlCYOProductPageBuilder';
import CovidWarningPopup from './Partials/CovidWarningPopup';
import PDPDeliveryPopupContainer from './Partials/GraphqlPDPDeliveryPopup/PDPDeliveryPopupContainer';
import pdpDictionary from './translations/pdpTranslations.json';
import { addLibraries } from '../../../helpers/commonFunctions';

const GraphqlPDPDataWrapper = loadable(() => import(/* webpackChunkName: "GraphqlPDPDataWrapper" */ './Partials/GraphqlPDPDataWrapper'));

const monthList = app?.ducks?.common?.selectors?.monthList;

const {
    common: {
        commonSelectors: {
            getCartError,
            getLoaderStatus,
            getPassportData,
        },
        commonDucks: {
            error: {
                errorActions: {
                    clearErrors,
                },
            },
        },
    },
} = checkoutDucks;

const styles = (theme) => ({

    foodRoot: {
        width: '98%',
        margin: 'auto',
    },
    flowerRoot: {
        width: '100%',
        margin: 'auto',
    },
    contentTop: {
        // Desktop
        margin: '0px auto',
        maxWidth: '1380px',
        color: theme.palette.black,
        // Tablet
        [theme.breakpoints.down('md')]: {
            margin: '20px 20px 30px',
        },
        // Mobile
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
        [theme.breakpoints.down('sm')]: {
            margin: '0 0 10px 0',
        },
    },
    contentLeft: {
        width: '100%',
        // Tablet
        [theme.breakpoints.down('md')]: {
            flex: '1 1 auto',
            display: 'flex',
            maxWidth: '40%',
            marginRight: '20px',
            flexDirection: 'column',
        },
        // Mobile
        [theme.breakpoints.down(600)]: {
            maxWidth: '100%',
        },
        marginRight: '24px',
        maxWidth: '665px',
    },
    contentRight: {
        width: '100%',
        maxWidth: '980px',
        // Tablet
        [theme.breakpoints.down('md')]: {
            width: 'calc(60% - 20px)',
            display: 'flex',
            flexDirection: 'column',
        },
        // Mobile
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    contentBottom: {
        width: '100%',
        margin: '40px auto 60px auto',
        maxWidth: '1380px',
        // Tablet
        [theme.breakpoints.down('md')]: {
            padding: '0 20px 0',
        },
        // Mobile
        [theme.breakpoints.down('sm')]: {
            margin: '0 0 15px 0',
            padding: '0',
        },
    },
    yotpoRatings: {
        '& .yotpo-main-widget .bottom-line-items': {
            display: 'none',
        },
        '& .yotpo-main-widget .yotpo-bottomline-box-1': {
            display: 'none',
        },
        '& .yotpo-main-widget .yotpo-bottomline-box-2': {
            display: 'none',
        },
        '& .yotpo-main-widget .reviews-amount': {
            visibility: 'hidden',
            position: 'relative',
            '&:after': {
                visibility: 'visible',
                position: 'absolute',
                content: '"Selected Customer Reviews"',
                top: 0,
                left: 0,
                width: '200px',
            },
        },
        '& .yotpo-main-widget .yotpo-nav ul li:first-child': {
            minWidth: '210px',
            visibility: 'hidden',
            position: 'relative',
            '&:after': {
                visibility: 'visible',
                position: 'absolute',
                content: '"Selected Customer Reviews"',
                top: 0,
                left: 0,
                width: '200px',
            },
        },
    },
    breadCrumbBody: {
        display: 'none',
        margin: '30px auto 10px auto',
        maxWidth: 1380,
        [theme.breakpoints.down('md')]: {
            padding: '0 20px 0',
        },
        // Desktop & Tablet
        '&--desktop': {
            [theme.breakpoints.up('sm')]: {
                display: 'flex',
            },
        },
        // Mobile
        '&--mobile': {
            [theme.breakpoints.down('sm')]: {
                display: 'flex',
                justifyContent: 'center',
            },
        },
        '&--mobile.club-mobile-pdp': {
            [theme.breakpoints.down('sm')]: {
                display: 'block',
                textAlign: 'left',
                padding: '0 10px 0',
                '& li': {
                    display: 'inline-block',
                },
                '& ol': {
                    textAlign: 'left',
                },
            },
        },
    },
    productName: {
        width: '100%',
        marginTop: 0,
        fontSize: '27px',
        lineHeight: '40px',
        marginBottom: 0,
        [theme.breakpoints.down('md')]: {
            marginBottom: '10px',
        },
        // Mobile
        [theme.breakpoints.down(600)]: {
            display: 'none',
        },
    },
    productRatingContainer: {
        width: '370px',
    },
    saLogo: {
        height: '43px',
        marginLeft: '-25px',
    },
    reviewCountContainer: {
        display: 'flex',
        alignItems: 'center',
        height: '10px',
    },
    ratingStars: {
        display: 'inline-block',
        margin: '0 17px 0 0',
        height: '19px',
        '& svg': {
            width: '20px',
            height: 'auto',
            color: '#E4984B',
        },
    },
    reviewCount: {
        display: 'inline-block',
        color: '#B6B6B6',
        fontSize: '15px',
        lineHeight: '14px',
    },
    contentBottomDivider: {
        margin: '40px 0 15px 0',
        textAlign: 'center',
        width: '100%',
        '&--title': {
            margin: '0',
            textAlign: 'center',
            fontSize: '16px',
            fontWeight: '600',
        },
    },
    passportEligibleImage: {
        width: '24%',
        [theme.breakpoints.down('md')]: {
            width: '45%',
            marginBottom: '10px',
        },
        [theme.breakpoints.down(600)]: {
            width: '38%',
            margin: '0 auto 5px',
        },
    },
});

const appConfigSelectors = app.ducks.config.selectors;

const {
    shopRunner: { shopRunnerActions },
} = memberDucks;

class GraphqlProductPageBuilder extends React.Component {
    constructor(props) {
        super(props);

        // the SKUs can come back in an unpredictable order but they should either be displayed highest price to lowest
        // or lowest to highest which will be set by product in CMS. The following lines sort the SKUs based on that CMS data
        // .slice is used as to not modify props
        const {
            content, product, presentation_family, brandId, productBaseContent, featureFlags,
        } = this.props;

        const isFoodBrand = (presentation_family === 'food');
        const productSkus = product ? product.productSkus : null;
        const sku_ranking = productBaseContent?.entries?.[0]?.sku_section?.sku_ranking || content?.entries?.[0]?.sku_section?.sku_ranking;
        if (productSkus) {
            if (sku_ranking === 'low to high') {
                this.sortedData = productSkus
                    .slice(0)
                    .sort(
                        (a, b) => Number(a.prices?.[0]?.value) - Number(b.prices?.[0]?.value),
                    );
            } else if (sku_ranking === 'high to low') {
                this.sortedData = productSkus
                    .slice(0)
                    .sort(
                        (a, b) => Number(b.prices?.[0]?.value) - Number(a.prices?.[0]?.value),
                    );
            } else if (sku_ranking === 'next available date') {
                this.sortedData = productSkus
                    .slice(0)
                    .sort(
                        (a, b) => new Date(dateStringReformat(a.availability.earliestShipDate)).getTime() - new Date(dateStringReformat(b.availability.earliestShipDate)).getTime(),
                    );
            } else {
                this.sortedData = productSkus
                    .slice(0)
                    .sort(
                        (a, b) => Number(b.prices?.[0]?.value) - Number(a.prices?.[0]?.value),
                    );
            }
            if (brandThemes[brandId]) {
                mbpLogger.logDebug({
                    message: `GraphqlProductPageBuilder: brandThemes is set for brand "${brandId}"`,
                    brandTheme: brandThemes[brandId],
                });
            } else {
                mbpLogger.logDebug({
                    message: `GraphqlProductPageBuilder: brandThemes is NOT set for brand "${brandId}"`,
                });
            }
            const setImplementProductSubscription = (brandThemes[brandId]?.implement_product_subscription || false);
            this.state = {
                selectedSku: this.sortedData[0],
                hasAddons: (product?.addonGroups?.length > 0),
                subscription: {
                    subscriptionKey: ['CMC-SubscriptionDuration-v2', 'CMC-SubscriptionType-v2', 'CMC-SubscriptionInterval-v2'],
                    subscriptionIndefinite: 'Continue until I stop',
                    subscriptionType: ['basic', 'discovery'],
                    implementProductSubscription: setImplementProductSubscription,
                    viewSubscription: false,
                    isTypeDiscovery: false,
                    subscriptionCheckbox: false,
                },
                subscriptionDetails: {
                    subscriptionType: '',
                    subscriptionDuration: '',
                    subscriptionFrequency: '',
                    subscriptionDurationKey: '',
                },
                // club page handler
                isClubProductLoaded: false,
                clubSkuMonthGroup: {},
                clubComponents: [],
                clubUpsells: [],
                hasWine: (this.sortedData[0].ageVerifyFlag === 'true'),
                isAddToCartEnabled: !(this.sortedData[0].ageVerifyFlag === 'true'),
                loader: false,
                slectedNonUpsellSku: this.sortedData[0],
                disableAddToCart: false,
                personalizedData: {},
                minicartModalOpen: false,
                quantity: '1',
                baseProduct: null,
                mobileAgeVerificationOpen: false,
                addToCartData: null,
                covidWarningOpen: false,
            };
            if (isFoodBrand) {
                if (!(featureFlags['is-club-pdp-from-pim'] && product?.productType?.toLowerCase() === 'club')) {
                    const productUpsell = product ? product.upsells : [];
                    this.sortedData = [...this.sortedData, ...productUpsell];
                }
            }
            this.getProductPageComponents();
        }
    }

    async componentDidMount() {
        const {
            loadSr,
            featureFlags,
            presentation_family,
            product,
            resetAgeVerificationFlag,
            isPla,
            urlParams,
            removeGCIData,
            callClearErrors,
            location,
            locationType,
        } = this.props;
        const { isClubProductLoaded, selectedSku } = this.state;
        if (locationType === 'Hospital') {
            this.setState({
                covidWarningOpen: true,
            });
        }

        await this.getBreadcrumbsDependingOnLocation();

        if (presentation_family === 'food' && product?.productType?.toLowerCase() === 'club') {
            const productID = product?.partNumber;
            if (!isClubProductLoaded) {
                this.getClubSku(productID, false, null, true);
            }
        }

        const isShopRunnerEnabled = featureFlags?.['is-shoprunner-enabled'];
        if (isShopRunnerEnabled) {
            loadSr(); // calls shoprunner scripts to load
        }
        if (presentation_family === 'food') {
            this.productSubscription();
        }
        resetAgeVerificationFlag(false);

        if (urlParams) {
            /**
             * PLA Channel
             * - Partnumber from PLA is contained in either `sku` or `adid` param
             * - Order of url params are not constant. Below accounts for param as first value or n+1
             */
            if (isPla || location.search.includes('sku')) {
                const partNumber = urlParams?.['?adid'] || urlParams?.adid || urlParams?.['?sku'] || urlParams?.sku;
                this.setDefaultSku(partNumber);
            }
            /**
             * PDP Default Sku Select
             * - Example, sku is only url param (e.g. ?123456M)
             */
            if (Object.keys(urlParams).length === 1 && !selectedSku) {
                const selectedPartNumber = location.search.split('?')[1];
                if (/\d/.test(selectedPartNumber)) {
                    this.setDefaultSku(selectedPartNumber);
                }
            }
        }
        removeGCIData({});
        const APP_YOTPO_CLIENT_ID = mbpUtil.getEnv('APP_YOTPO_CLIENT_ID');
        const yotpoClientURL = `https://staticw2.yotpo.com/${APP_YOTPO_CLIENT_ID}/widget.js`;
        addLibraries(yotpoClientURL, '', false, true);
        callClearErrors({ errType: 'cart', field: 'error' });
    }

    componentDidUpdate(prevProps) {
        const {
            brandId, loadSr, featureFlags, locationType,
        } = this.props;
        const isShopRunnerEnabled = featureFlags?.['is-shoprunner-enabled'];
        // Fall back to call only if brandId is set
        if (prevProps.brandId !== brandId && isShopRunnerEnabled) {
            loadSr();
        }

        if (locationType === 'Hospital' && prevProps.locationType !== 'Hospital') {
            this.setState({
                covidWarningOpen: true,
            });
        }
    }

    setProductQuantity = (qty) => {
        const quantity = qty || '1';
        this.setState({
            quantity,
        });
    }

    handleMobileAgeVerification = (flag, addToCartData = null) => {
        this.setState({
            mobileAgeVerificationOpen: flag,
            addToCartData,
        });
    }

    closeCovidWarning = () => {
        this.setState({
            covidWarningOpen: false,
        });
    }

    changeClubLength = async (productId, skuSelected) => {
        const hasUpsells = this.sortedData.findIndex((sku) => (sku?.isUpsellSku));
        if (hasUpsells >= 0) {
            this.sortedData.splice(hasUpsells, 1);
            this.sortedData = this.sortedData.slice(0)
                .sort(
                    (a, b) => Number(b.prices[0].value) - Number(a.prices[0].value),
                );
        }
        const data = await this.getClubComponents(productId, true);
        if (data?.item) {
            const { clubSkuMonthGroup } = this.state;
            const setFetchedClubMonths = clubSkuMonthGroup;
            const fetchedComponents = data?.item?.components || [];
            Object.keys(clubSkuMonthGroup).forEach((month) => {
                const hasComponent = fetchedComponents.filter((component) => component?.month === clubSkuMonthGroup[month]?.[0]?.date?.month);
                if (hasComponent.length === 0 && clubSkuMonthGroup[month].length > 0) {
                    setFetchedClubMonths[month][0].fade = true;
                } else {
                    setFetchedClubMonths[month][0].fade = false;
                }
            });

            this.setState({
                selectedSku: this.sortedData.find((sku) => sku.id === skuSelected),
                clubSkuMonthGroup: setFetchedClubMonths,
                clubComponents: fetchedComponents,
                clubUpsells: data?.item?.upsells || [],
                selectedClubUpsells: null,
                slectedNonUpsellSku: this.sortedData.find((sku) => sku.id === skuSelected),
            });
        }
    }

    changeClubMonth = (sku) => {
        if (sku?.partNumber || sku?.id) {
            this.getClubSku(sku?.partNumber || sku?.id, true);
        }
    }

    changeClubUpsell = async (productId, deleteOnly = false) => {
        const { featureFlags } = this.props;
        if (productId) {
            const upsellToSku = {};
            upsellToSku.isUpsellSku = true;
            const { slectedNonUpsellSku } = this.state;
            const hasAlready = this.sortedData.filter((sku) => sku.id === productId);
            const hasUpsells = this.sortedData.findIndex((sku) => (sku?.isUpsellSku));
            if (deleteOnly && hasUpsells >= 0) {
                this.sortedData.splice(hasUpsells, 1);
                this.sortedData = this.sortedData.slice(0)
                    .sort(
                        (a, b) => Number(b.prices[0].value) - Number(a.prices[0].value),
                    );
                this.setState({
                    selectedSku: slectedNonUpsellSku,
                    selectedClubUpsells: null,
                });
                return;
            }
            if (hasAlready.length) {
                this.setState({
                    selectedSku: hasAlready[0],
                });
                return;
            }
            let data = await this.getClubComponents(productId, false, false);
            const { selectedSku } = this.state;
            if (featureFlags['is-club-pdp-from-pim']) {
                data = await this.getClubComponents(productId, false, false, true);
            }
            Object.keys(selectedSku).forEach((skuKey) => {
                if (typeof data[skuKey] === 'undefined') {
                    upsellToSku[skuKey] = selectedSku[skuKey];
                } else {
                    upsellToSku[skuKey] = data[skuKey];
                }
            });
            this.getClubSku(productId, true, upsellToSku);
        }
    }

    getClubSku = (productID, items = false, preSelectedSku = null, initialLoad = false) => {
        const hasUpsells = this.sortedData.findIndex((sku) => (sku?.isUpsellSku));
        if (hasUpsells >= 0) {
            this.sortedData.splice(hasUpsells, 1);
            this.sortedData = this.sortedData.slice(0)
                .sort(
                    (a, b) => Number(b.prices[0].value) - Number(a.prices[0].value),
                );
        }
        let skuData = this.sortedData;
        this.getClubComponents(productID, items).then(
            (data) => {
                let componentClubData = {};
                if (data) {
                    componentClubData = data;
                }
                const availableMonth = componentClubData.item?.description?.month || monthList[new Date().getMonth()];
                const clubSku = [];
                const skuMonthGroup = {};
                skuData = skuData.slice(0)
                    .sort(
                        (a, b) => new Date(dateStringReformat(a?.availability?.earliestShipDate)).getTime() - new Date(dateStringReformat(b?.availability?.earliestShipDate)).getTime(),
                    );

                skuData.forEach((sku) => {
                    const skuMapper = sku;
                    const skuMonth = monthList[new Date(dateStringReformat(sku.availability?.earliestShipDate)).getMonth()];
                    const dateObject = {
                        month: skuMonth,
                        year: new Date(dateStringReformat(sku.availability?.earliestShipDate))?.getFullYear(),
                        day: new Date(dateStringReformat(sku.availability?.earliestShipDate))?.getDate(),
                    };
                    skuMapper.partNumber = sku.partNumber || sku.id || null;
                    skuMapper.dateInt = `${dateObject.year}-${dateObject.month}-${dateObject.day}`;
                    skuMapper.date = dateObject;
                    skuMapper.fade = false;
                    skuMapper.fullDate = new Date(dateStringReformat(sku.availability?.earliestShipDate));
                    skuMapper.isSelectedMonth = (availableMonth === monthList[new Date(dateStringReformat(skuMapper?.availability?.earliestShipDate)).getMonth()]);
                    if (typeof skuMonthGroup[skuMonth] !== 'undefined') {
                        skuMonthGroup[skuMonth].push(skuMapper);
                    } else if (skuMonth) {
                        skuMonthGroup[skuMonth] = [];
                        skuMonthGroup[skuMonth].push(skuMapper);
                    }
                    if (!items) {
                        const clubMapper = componentClubData.allItemSummary?.filter((item) => item?.id === sku.legacyId) || [];
                        skuMapper.clubLength = clubMapper[0]?.frequency || 0;
                        skuMapper.tagline = clubMapper[0]?.frequency === '12' ? 'Best value' : null;
                        const startDate = new Date(dateStringReformat(sku.availability?.earliestShipDate));
                        const componentEndDate = startDate.setMonth(startDate.getMonth() + (Number(clubMapper[0]?.frequency) - 1));
                        if (componentEndDate) {
                            skuMapper.endDate = {
                                month: monthList[new Date(componentEndDate)?.getMonth()],
                                year: new Date(componentEndDate)?.getFullYear(),
                            };
                        }
                    }
                    clubSku.push(skuMapper);
                });

                Object.keys(skuMonthGroup).forEach((month) => {
                    skuMonthGroup[month] = skuMonthGroup[month].slice(0)
                        .sort(
                            (a, b) => Number(b.prices[0].value) - Number(a.prices[0].value),
                        );
                });
                skuData = clubSku;
                if (skuData) {
                    skuData = skuData
                        .slice(0)
                        .sort(
                            (a, b) => Number(b.prices[0].value) - Number(a.prices[0].value),
                        );

                    let selectedSku = skuData?.filter((sku) => (sku.partNumber === productID));
                    if (initialLoad) {
                        selectedSku = skuData?.[0];
                    }

                    if (selectedSku.length === 0) {
                        selectedSku = skuData?.filter((sku) => sku.date.month === availableMonth);
                    }

                    const { clubUpsells, clubSkuMonthGroup, slectedNonUpsellSku } = this.state;
                    let upsellsCollections = componentClubData.item?.upsells || [];
                    let clubSkuMonthCollections = skuMonthGroup;
                    let skuSelection = selectedSku.length > 0 ? selectedSku[0] : skuData[0];
                    if (preSelectedSku) {
                        this.sortedData.push(preSelectedSku);
                        skuSelection = preSelectedSku;
                        upsellsCollections = clubUpsells;
                        clubSkuMonthCollections = clubSkuMonthGroup;
                        this.sortedData = this.sortedData.slice(0)
                            .sort(
                                (a, b) => Number(b.prices[0].value) - Number(a.prices[0].value),
                            );
                    }
                    this.setState({
                        clubComponents: componentClubData.item?.components || [],
                        clubUpsells: upsellsCollections,
                        isClubProductLoaded: true,
                        selectedSku: skuSelection,
                        slectedNonUpsellSku: preSelectedSku ? slectedNonUpsellSku : skuSelection,
                        clubSkuMonthGroup: clubSkuMonthCollections,
                        selectedClubUpsells: preSelectedSku?.id || null,
                    });
                }
            },
        );
    }

    getClubDataFromObject = (product, type = 'product') => {
        if (type === 'product') {
            const modifyData = {
                item: {
                    ...product?.defaultSku,
                    description: {
                        startDate: product?.defaultSku?.startDate,
                        availableDate: product?.defaultSku?.availableDate,
                        month: product?.defaultSku?.month,
                        fullImage: product?.defaultSku?.image?.name,
                    },
                },
                brandId: '',
                priceRange: '',
                allItemSummary: {},
                description: {},
            };
            modifyData.allItemSummary = product?.allItemsList;
            return modifyData;
        }
        const modifyData = {
            item: {
                ...product,
                description: {
                    startDate: product?.startDate,
                    availableDate: product?.availableDate,
                    month: product?.month,
                    fullImage: product?.image?.name,
                    name: product?.name,
                },
            },
        };
        return modifyData;
    }

    getProductByPartNumber = (query) => {
        const { client } = this.props;
        return client.query({ query }).then((res) => res);
    }

    getProductPageComponents = () => {
        const {
            brand, baseProductPartNumber, currencyData = {}, featureFlags,
        } = this.props;
        let { currencyName } = currencyData?.currencyName || 'USD';
        const isInternationalization = featureFlags['is-internationalization-enabled'];
        if (isInternationalization) {
            if (currencyName === 'USD') {
                currencyName = 'CAD';
            }
            currencyName = 'CAD';
        }
        const { baseProduct } = this.state;
        if (baseProductPartNumber) {
            const PRODUCT_BY_PART = productPageQueries(brand?.domain, baseProductPartNumber, currencyName);
            this.getProductByPartNumber(PRODUCT_BY_PART).then((res) => {
                const productSku = res?.data?.findProductByPartNumber?.productSkus || [];
                const upsellSku = productSku.find((sku) => getBaseCode(baseProductPartNumber) === getBaseCode(sku?.id)) || null;
                if (upsellSku) {
                    upsellSku.id = res?.data?.findProductByPartNumber?.partNumber || null;
                    // eslint-disable-next-line no-underscore-dangle
                    upsellSku.__typename = 'Upsell';
                    this.sortedData.push(upsellSku);
                    if (baseProduct?.[0]?.id !== upsellSku?.id && baseProductPartNumber) {
                        this.setState({
                            baseProduct: [upsellSku],
                        });
                    }
                }
            }).catch((error) => {
                mbpLogger.logError({
                    query: PRODUCT_BY_PART,
                    component: 'GraphqlProductPageBuilder.js',
                    message: 'Error loading data from Graphql',
                    env: GRAPHQL_ENV,
                    error,
                });
            });
        }
    }

    getClubQuery = (query) => {
        const { client } = this.props;
        return client.query({ query }).then((res) => res);
    }

    getBreadcrumbsGql = (query) => {
        const { client } = this.props;
        return client.query({ query }).then((res) => res);
    }

    getBreadcrumbsDependingOnLocation = async () => {
        const { brand, location } = this.props;

        if (location) {
            if (location.state?.prevUrl?.split('/')[2] === 'c') {
                const prevPathname = location.state?.from?.split('/').slice(2).join('/');
                const currentPathname = location.pathname?.split('/').slice(2).join('/');
                if (prevPathname === currentPathname) {
                    const categoryPath = location.state?.prevUrl.split('/').slice(3);
                    const FIND_CATEGORY_BY_URL = findCategoryPageByURL(brand?.domain, `/${categoryPath}`);
                    await this.getBreadcrumbsGql(FIND_CATEGORY_BY_URL).then((res) => {
                        const breadCrumbArray = res?.data?.findCategoryPageByUrl?.content?.entries?.[0]?.seo?.breadcrumb || [];
                        this.setState({
                            breadcrumb: breadCrumbArray,
                        });
                    }).catch((error) => {
                        mbpLogger.logError({
                            query: FIND_CATEGORY_BY_URL,
                            component: 'GraphqlProductPageBuilder.js',
                            message: 'Error loading data from Graphql',
                            env: GRAPHQL_ENV,
                            error,
                        });
                    });
                }
            }
        }
    }

    getClubComponents = async (productId, items = false, isComponent = true, isAddons = false) => {
        this.setState({ loader: true });
        const { brand, featureFlags } = this.props;
        const { findClubData, findSkuById } = clubQueries;

        const PRODUCT_CLUBS = findClubData(brand?.domain, productId);

        const clubDataByService = new Promise(((resolve) => {
            if (items || (featureFlags['is-club-pdp-from-pim'] && isAddons)) {
                if (featureFlags['is-club-pdp-from-pim']) {
                    const PRODUCT_CLUBS_ITEMS = findSkuById(brand?.domain, productId);
                    this.getClubQuery(PRODUCT_CLUBS_ITEMS).then(({ data }) => {
                        this.setState({ loader: false });
                        if (!items) {
                            resolve(data?.findSkuById);
                        } else {
                            resolve(this.getClubDataFromObject(data?.findSkuById?.clubItem, 'items'));
                        }
                    });
                } else {
                    this.getClubQuery(PRODUCT_CLUBS).then((res) => {
                        const legacyId = res?.data?.findProductByPartNumber?.legacyId;
                        const PRODUCT_CLUBS_ITEMS = findSkuById(brand?.domain, legacyId);
                        this.getClubQuery(PRODUCT_CLUBS_ITEMS).then(({ data }) => {
                            this.setState({ loader: false });
                            resolve(this.getClubDataFromObject(data?.findSkuById?.clubItem, 'items'));
                        });
                    });
                }
            } else {
                this.getClubQuery(PRODUCT_CLUBS).then((res) => {
                    const data = res?.data?.findProductByPartNumber?.club;
                    this.setState({ loader: false });
                    if (isComponent) {
                        resolve(this.getClubDataFromObject(data));
                    }
                    resolve(res?.data?.findProductByPartNumber);
                });
            }
        }));

        const clubReturnData = await clubDataByService;
        return clubReturnData;
    }

    updateWineStatus = () => { }

    handleMiniCartModalClick = (setModal) => {
        const { minicartModalOpen } = this.state;
        if (minicartModalOpen !== setModal) {
            this.setState({ minicartModalOpen: setModal });
        }
    };

    handleSkuChange = (e) => {
        const submitSlectedSku = this.sortedData.find((sku) => sku.id === e.target.value);
        this.setState({
            selectedSku: submitSlectedSku,
            hasWine: (submitSlectedSku.ageVerifyFlag === 'true'),
            isAddToCartEnabled: !(submitSlectedSku.ageVerifyFlag === 'true'),
        });
    };

    // @intention: Checks deliveryMessage string in solar.
    //  - If string contains 'florist' return FPT message
    //  - If string contains 'box' return GPT message
    // @return: Delivery message string to display on page from ContentStack
    getDeliveryMessage = (content, deliveryMessage, productDeliveryType) => {
        if (content && content.entries && content.entries[0]) {
            if (deliveryMessage.toLowerCase().includes('florist') || productDeliveryType === 'FPT') {
                return content.entries[0].delivery_method_section[0];
            }
            if (deliveryMessage.toLowerCase().includes('box') || productDeliveryType === 'GPT') {
                return content.entries[0].delivery_method_section[1];
            }
        }
        mbpLogger.logWarning({
            component: 'GraphqlProductPageBuilder.js',
            message: 'No data returned for delivery message',
        });
        return {};
    };

    renderProductReviews = (enabled, currentPage, classes) => {
        if (enabled && currentPage) {
            return (
                <Media
                    query="(min-width: 600px)"
                    render={() => (
                        <div className={classes.productRatingContainer}>
                            <div className={classes.saLogo}>
                                <img src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltab0819c5ba8dff60/5e28ea9fe2b3975498eaf8d3/salogo.png" width="119" height="39" alt="Shopper Approved Logo" />
                            </div>
                            <div className={classes.reviewCountContainer}>
                                <div className={classes.ratingStars}>
                                    <Star />
                                    <Star />
                                    <Star />
                                    <Star />
                                    <StarHalf />
                                </div>
                                <p className={classes.reviewCount}>(254,268 reviews)</p>
                            </div>
                        </div>
                    )}
                />
            );
        }
        return null;
    };

    renderCollection = (enabled, currentPage, classes, urlParams) => {
        // @intention:
        //  - check adcampaign param in url for keyword
        //  - return cateegoryId based on keyword
        // @return: {object}
        const getCategoryId = () => {
            // Set default category to flowers
            let categoryId = '400215581';

            const adCampaign = urlParams?.adcampaign?.toLowerCase() || null;

            if (adCampaign?.includes('flowers')) { categoryId = '400215581'; }
            if (adCampaign?.includes('roses')) { categoryId = '400065018'; }
            if (adCampaign?.includes('sympathy')) { categoryId = '400065005'; }
            if (adCampaign?.includes('plants')) { categoryId = '400077286'; }
            if (adCampaign?.includes('baskets')) { categoryId = '400067500'; }
            return categoryId;
        };

        // @intention: set default filter data for collection
        const filterData = {
            lowToHighBtn: '',
            highToLowBtn: '',
            sellingBtn: '',
            giftBox: '',
            localFlorist: '',
        };

        if (enabled && currentPage) {
            return (
                <div className={classes.contentBottom}>
                    <div className={classes.contentBottomDivider}>
                        <p className={`${classes.contentBottomDivider}--title`}>Customers also bought</p>
                    </div>
                    <ProductListingAdCategoryContainer filterData={filterData} categoryId={getCategoryId()} />
                </div>
            );
        }
        return null;
    };

    /**
     * @description This will extract the subscription data and maintain the state of intial selection in case of Discovery type
     * @memberof GraphqlProductPageBuilder
     */
    productSubscription = () => {
        const {
            subscription,
            subscription: {
                subscriptionKey,
                subscriptionIndefinite,
                subscriptionType,
                implementProductSubscription,
            },
        } = this.state;
        const {
            product,
        } = this.props;
        const attribute = product?.attributes;
        const setSubscriptionDetails = {};
        if (attribute && attribute.length > 0) {
            attribute.filter((subscriptionObj) => {
                const attributeKey = subscriptionObj?.id;
                const checkAttribute = subscriptionKey.includes(attributeKey);
                if (checkAttribute) {
                    const value = subscriptionObj?.values[0]?.value;
                    if (subscriptionKey[0] === attributeKey) {
                        setSubscriptionDetails.subscriptionDuration = (/Indefinite/gi.test(value)) ? subscriptionIndefinite : value;
                        setSubscriptionDetails.subscriptionDurationKey = value;
                    } else if (subscriptionKey[1] === attributeKey) {
                        setSubscriptionDetails.subscriptionType = value;
                    } else if (subscriptionKey[2] === attributeKey) {
                        setSubscriptionDetails.subscriptionFrequency = value;
                    }
                    return subscriptionObj;
                }
                return false;
            });
        }
        if (setSubscriptionDetails && setSubscriptionDetails.subscriptionType && setSubscriptionDetails.subscriptionType !== '') {
            const subscriptionTypeInfo = setSubscriptionDetails.subscriptionType.toLowerCase();
            let isTypeDiscovery = false;
            let viewSubscription = false;
            // this will check if the type is discovery
            if (subscriptionTypeInfo !== '') {
                isTypeDiscovery = (subscriptionTypeInfo === subscriptionType[1]);
                viewSubscription = (implementProductSubscription && subscriptionTypeInfo !== '');
            }
            // if the type is discovery by default it proceed as a default selected subscription
            const subscriptionCheckbox = (isTypeDiscovery);
            this.setState({
                subscriptionDetails: setSubscriptionDetails,
                subscription: {
                    ...subscription, isTypeDiscovery, viewSubscription, subscriptionCheckbox,
                },
            });
        }
    }

    triggerSubscriptionCheck = (event, newValue) => {
        const { subscription } = this.state;
        this.setState({ subscription: { ...subscription, subscriptionCheckbox: newValue } });
    }

    handlePersonalizeInputChange = (valueCount) => {
        if (valueCount === 0) {
            this.setState({ disableAddToCart: true });
        } else {
            this.setState({ disableAddToCart: false });
        }
    }

    /**
     * @description Render the mini cart
     */
    getMiniCart = () => {
        const {
            showLoadingMessage, product, presentation_family, cartError, isPassportBundleProduct,
        } = this.props;
        const { minicartModalOpen } = this.state;
        return (
            <>
                {(showLoadingMessage && minicartModalOpen)
                    && (
                        <SiteLoader />
                    )}

                {
                    cartError === ''
                    && (
                        <MiniCart
                            handleMiniCartModalClick={this.handleMiniCartModalClick}
                            minicartModalOpen={minicartModalOpen}
                            product={product}
                            presentation_family={presentation_family}
                            isPassportBundleProduct={isPassportBundleProduct || {}}
                        />
                    )
                }

            </>
        );
    }

    getUpdatedPersonalizedProdData = (personalizedData) => {
        if (personalizedData) {
            this.setState({ personalizedData });
        }
    }

    /**
     * @description Checks url for partnumber and sets default sku
     * @param {object} object — url parameters
     */
    setDefaultSku = (partNumber) => {
        let updatedSlectedSku = null;
        const skuData = this.sortedData;
        skuData.forEach((sku) => {
            if (sku.id.includes(partNumber)) {
                updatedSlectedSku = sku;
                return updatedSlectedSku;
            }
            return null;
        });
        if (updatedSlectedSku) {
            this.setState({
                selectedSku: updatedSlectedSku,
            });
        }
    }

    // Track Product
    @track(trackProductData)
    render() {
        const { covidWarningOpen } = this.state;
        const {
            classes,
            content,
            seoData,
            product,
            location,
            urlParams,
            isPlaEnabled,
            isPla,
            featureFlags,
            presentation_family,
            brand,
            isPassportBundleItem,
            addressSource,
            cartError,
            isPassportBundleProduct,
            passportData,
            productBaseContent,
            currencyData,
        } = this.props;
        if (GRAPHQL_ENV === 'development') {
            console.log('ProductPageBuilder content -----> ', content);
            console.log('ProductPageBuilder product -----> ', product);
        }

        // const skuData = product.productSkus;
        let skuConfig = {};
        let deliveryData = {};
        let smartGiftLetThemKnowSection = {};
        let passportMemberImg = '';
        let productUrl = '';
        const giftProduct = {
            giftUrl: '',
            sku: '',
            collection: '',
        };
        // let giftUrl = '';
        // let sku = '';
        // let collection = '';

        const productDisplay = content?.entries?.[0]?.product_name_display;
        if (content?.entries?.[0]) {
            skuConfig = content.entries[0].sku_section;
            deliveryData = content.entries[0].delivery_section;
            smartGiftLetThemKnowSection = content.entries[0].smart_gift_let_them_know_section;
            giftProduct.giftUrl = content.entries[0].smart_gift_address_section?.link?.href;
            passportMemberImg = content.entries[0].passport_banner_section?.member_image;
            productUrl = content.entries[0].url;
        }
        const deliveryMessage = product && product.availability && product.availability.deliveryMessage ? product.availability.deliveryMessage : '';
        const productDeliveryType = product && product.availability && product.availability.productDeliveryType ? product.availability.productDeliveryType : '';
        if (product) {
            const {
                partNumber, shortDescription, longDescription, name, productSkus, isPassportEligible, productContents, reviews,
            } = product;
            const {
                selectedSku, subscriptionDetails, subscription, clubSkuMonthGroup, clubUpsells, clubComponents, disableAddToCart, personalizedData, hasWine, isAddToCartEnabled, selectedClubUpsells, hasAddons, quantity, baseProduct, mobileAgeVerificationOpen, addToCartData,
                breadcrumb,
            } = this.state;
            const breadCrumbArray = getBreadcrumbArray(product, location, breadcrumb);

            /**
             * @description Smartgift feature visability
             * - Hide smartgift on SCI channel
             * - Display smartgift if flag is enabled
             * @return {bool} bool
             */
            const isSmartGiftEnabled = () => {
                if (addressSource === 'SCI') return false;
                if (featureFlags?.['is-smart-gift-enabled']) return true;
                return false;
            };
            const isCovidWarningPopupEnabled = featureFlags['is-pdp-covid-popup-warning-enabled'];
            let personalization;
            if (productSkus.length) {
                productSkus.forEach((sku) => {
                    personalization = sku.personalization;
                });
            }

            /**
             * @description - Passport elagibiility banner
             * - Hide banner on SCI channel
             * - Display banner if product is eligable and flag is enabled
             * @return {bool}
             */
            const renderPassportBanner = () => {
                if (addressSource === 'SCI') return false;
                // Disable if we get valid cookie "passportUpSell"
                const cookies = new Cookies();
                if (cookies.get('passportUpSell')) return false;
                // flag from contentStack to show/hide passport banner on PDP Page
                const disablePassportEnrollment = passportData?.passport_up_sell_conditional_logic_at_entrance?.disable_passport_enrolment;
                if (disablePassportEnrollment) return false;
                // flag from contentStack for utm_param
                if (location?.search) {
                    const url = location.search.match('(utm_param)=([^&]+)');
                    if (url && url.length > 2 && url[1] === 'utm_param') {
                        if (passportData?.passport_up_sell_conditional_logic_at_entrance) {
                            const { utm_param, enable } = passportData.passport_up_sell_conditional_logic_at_entrance;
                            if (enable) {
                                if (url[2] === utm_param) return false;
                            }
                        }
                    }
                }
                if (isPassportEligible && featureFlags?.['is-prime-free-ship-icon-enabled']) return true;
                return false;
            };
            const enableMinicart = featureFlags['is-mini-cart-enabled'];
            if (presentation_family === 'food' && product?.productType === 'CUSTOM_ASSORTMENT') {
                // Render Custom PDP Layout
                return (
                    <div id="product_page_container">
                        {enableMinicart && this.getMiniCart()}
                        <GraphqlCYOProductPageBuilder
                            presentation_family={presentation_family}
                            brand={brand}
                            content={content}
                            seoData={seoData}
                            product={product}
                            urlParams={urlParams}
                            handleMiniCartModalClick={this.handleMiniCartModalClick}
                            cartError={cartError}
                            hasWine={hasWine}
                            mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                            handleMobileAgeVerification={this.handleMobileAgeVerification}
                            addToCartData={addToCartData}
                            deliveryData={deliveryData}
                            updateWineStatus={this.updateWineStatus}
                        />
                    </div>
                );
            }
            if (presentation_family === 'food' && product?.productType?.toLowerCase() === 'club') {
                const { loader } = this.state;
                return (
                    <>
                        {loader && <GraphqlPortalLoader />}
                        {enableMinicart && this.getMiniCart()}
                        {addOgDynamicData(product, seoData, brand, location)}
                        <GraphqlProductSeoSchema
                            name={getLanguageName() !== '/en' && brand?.code === 'CAN' ? pdpDictionary?.[`${partNumber}_name`] || name : name}
                            shortDescription={getLanguageName() !== '/en' && brand?.code === 'CAN' ? pdpDictionary?.[`${partNumber}_short_description`] || shortDescription : shortDescription}
                            partNumber={partNumber}
                            productSkus={productSkus}
                            location={location}
                            brand={brand}
                            reviews={reviews}
                        />
                        <div className={classes.root}>
                            <GraphqlClubProductPage
                                breadcrumbs={(<div className={`${classes.breadCrumbBody} ${classes.breadCrumbBody}--desktop`}> {getBreadcrumbArray(product, location, breadcrumb)}</div>)}
                                selectedSku={selectedSku}
                                skuMonths={clubSkuMonthGroup}
                                clubUpsells={clubUpsells}
                                clubComponents={clubComponents}
                                product={product}
                                location={location}
                                presentation_family={presentation_family}
                                skuConfig={skuConfig}
                                changeClubMonth={this.changeClubMonth}
                                changeClubLength={this.changeClubLength}
                                deliveryData={deliveryData}
                                breadCrumbArray={breadCrumbArray}
                                handleSkuChange={this.handleSkuChange}
                                sortedData={this.sortedData}
                                passportMemberImg={passportMemberImg}
                                productUrl={productUrl}
                                shortDescription={shortDescription}
                                longDescription={longDescription}
                                selectedClubUpsells={selectedClubUpsells}
                                changeClubUpsell={this.changeClubUpsell}
                                hasAddons={hasAddons}
                                handlePersonalizeInputChange={this.handlePersonalizeInputChange}
                                disableAddToCart={disableAddToCart}
                                getUpdatedPersonalizedProdData={this.getUpdatedPersonalizedProdData}
                                personalizedData={personalizedData}
                                personalization={personalization}
                                isAddToCartEnabled={isAddToCartEnabled}
                                handleMiniCartModalClick={this.handleMiniCartModalClick}
                                mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                                handleMobileAgeVerification={this.handleMobileAgeVerification}
                                addToCartData={addToCartData}
                                hasWine={hasWine}
                            />
                            <div className={`${classes.breadCrumbBody} ${classes.breadCrumbBody}--mobile club-mobile-pdp`}>{getBreadcrumbArray(product, location, breadcrumb)}</div>
                        </div>
                    </>
                );
            }
            let productName = ReactHtmlParser(product.name);
            if (getLanguageName() !== '/en' && brand?.code === 'CAN') { // temporary workaround for the pdp translations. Only applies for .CA
                productName = pdpDictionary?.[`${partNumber}_name`] || productName; // 1001-P-179167_name
            }
            if (isPassportBundleProduct?.enable) {
                const bundleText = passportData?.passport_bundle?.pdpage_passport_bundle_title || ' & Passport Bundle';
                productName = `${productName} ${bundleText}`;
            }

            return (
                <>
                    {isCovidWarningPopupEnabled && <CovidWarningPopup isOpen={covidWarningOpen} closeModal={this.closeCovidWarning} />}
                    {addOgDynamicData(product, seoData, brand, location)}
                    {enableMinicart && this.getMiniCart()}
                    <GraphqlProductSeoSchema
                        name={getLanguageName() !== '/en' && brand?.code === 'CAN' ? pdpDictionary?.[`${partNumber}_name`] || name : name}
                        shortDescription={getLanguageName() !== '/en' && brand?.code === 'CAN' ? pdpDictionary?.[`${partNumber}_short_description`] || shortDescription : shortDescription}
                        partNumber={partNumber}
                        productSkus={productSkus}
                        location={location}
                        brand={brand}
                        reviews={reviews}
                        currency={currencyData.currencyName}
                    />
                    <div className={`${presentation_family === 'food' ? classes.foodRoot : classes.flowerRoot}`}>
                        <div className={`${classes.breadCrumbBody} ${classes.breadCrumbBody}--desktop`}>{getBreadcrumbArray(product, location, breadcrumb)}</div>
                        <div className={classes.contentTop}>
                            <div className={classes.contentLeft}>
                                {/**
                                 * TODO:
                                 * - pull correct mobile vs tab breakpoint from cms
                                 * - add smart gift to mobile ui
                                 */}
                                <DesktopMobile
                                    mobile={() => (
                                        <GraphqlProductImageUIMobile
                                            productName={productName}
                                            product={product}
                                            content={content}
                                            selectedSku={selectedSku}
                                            presentation_family={presentation_family}
                                            productNameDisplay={productDisplay}
                                        />
                                    )}
                                    desktop={() => (
                                        <GraphqlProductImageUI
                                            data={product}
                                            selectedSku={selectedSku}
                                            location={location}
                                            presentation_family={presentation_family}
                                            isSmartGiftEnabled={isSmartGiftEnabled()}
                                            smartGiftLetThemKnowSection={smartGiftLetThemKnowSection}
                                            brand={brand}
                                        />
                                    )}
                                    breakpoint={600}
                                />
                            </div>
                            <div className={classes.contentRight}>
                                <>
                                    <div style={{ display: 'flex' }}>
                                        <h1 className={classes.productName}>{productName}</h1>
                                        {this.renderProductReviews(isPlaEnabled, isPla, classes)}
                                    </div>
                                    {presentation_family === 'flower'
                                        && renderPassportBanner() && <img className={classes.passportEligibleImage} src="https://cdn4.1800flowers.com/wcsstore/Flowers/images/2020/passport/PPEligibleIcon.jpg" alt="passport_eligible" />}
                                </>
                                {
                                    typeof window !== 'undefined' && (
                                        <GraphqlPDPDataWrapper
                                            product={product}
                                            hasWine={hasWine}
                                            setProductQuantity={this.setProductQuantity}
                                            quantity={quantity}
                                            updateWineStatus={this.updateWineStatus}
                                            isAddToCartEnabled={isAddToCartEnabled}
                                            skuConfig={skuConfig}
                                            deliveryData={deliveryData}
                                            presentation_family={presentation_family}
                                            selectedSku={selectedSku}
                                            handleSkuChange={this.handleSkuChange}
                                            sortedData={this.sortedData}
                                            passportMemberImg={passportMemberImg}
                                            productUrl={productUrl}
                                            subscriptionDetails={subscriptionDetails}
                                            subscription={subscription}
                                            triggerSubscriptionCheck={this.triggerSubscriptionCheck}
                                            location={location}
                                            brand={brand}
                                            isPassportBundleItem={isPassportBundleItem}
                                            handlePersonalizeInputChange={this.handlePersonalizeInputChange}
                                            disableAddToCart={disableAddToCart}
                                            getUpdatedPersonalizedProdData={this.getUpdatedPersonalizedProdData}
                                            personalizedData={personalizedData}
                                            personalization={personalization}
                                            hasAddons={hasAddons}
                                            handleMiniCartModalClick={this.handleMiniCartModalClick}
                                            baseProductSku={baseProduct}
                                            isPassportBundleProduct={isPassportBundleProduct || {}}
                                            mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                                            handleMobileAgeVerification={this.handleMobileAgeVerification}
                                            addToCartData={addToCartData}
                                            content={productBaseContent}
                                        />
                                    )
                                }
                                {(featureFlags['is-design-and-delivery-popup-enabled']) && (
                                    <div>
                                        <PDPDeliveryPopupContainer
                                            productDeliveryType={productDeliveryType}
                                            brand={brand}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                        {this.renderCollection(isPlaEnabled, isPla, classes, urlParams)}
                        <div className={`${classes.contentBottom} ${featureFlags?.['is-pdp-yotpo-ratings-enabled'] ? '' : classes.yotpoRatings}`}>
                            {featureFlags?.['is-delivery-type-shown'] && <GraphqlDeliveryMethodUI deliveryMethodData={this.getDeliveryMessage(content, deliveryMessage, productDeliveryType)} />}
                            {presentation_family === 'food' ? (
                                <GraphqlFoodProductDetailsTab
                                    shortDescription={shortDescription}
                                    productContents={productContents}
                                    longDescription={longDescription}
                                    productSkus={productSkus}
                                    selectedSku={selectedSku}
                                    content={content}
                                    isPassportBundleProduct={isPassportBundleProduct || {}}
                                />
                            ) : (
                                <GraphqlProductDetailsTab
                                    partNumber={partNumber}
                                    shortDescription={shortDescription}
                                    longDescription={longDescription}
                                    presentationFamily={presentation_family}
                                    isPassportBundleProduct={isPassportBundleProduct || {}}
                                />
                            )}
                            <div className={`${classes.breadCrumbBody} ${classes.breadCrumbBody}--mobile`}>{getBreadcrumbArray(product, location, breadcrumb)}</div>
                        </div>
                    </div>
                </>
            );
        }
        return <PDPSkeleton />;
    }
}

GraphqlProductPageBuilder.defaultProps = {
    brandId: '',
    addressSource: '',
    showLoadingMessage: false,
    baseProductPartNumber: null,
    cartError: '',
    passportData: {},
    isPassportBundleProduct: {},
};

GraphqlProductPageBuilder.propTypes = {
    classes: object.isRequired,
    content: object.isRequired,
    productBaseContent: object.isRequired,
    product: object.isRequired,
    location: object.isRequired,
    brandId: string,
    loadSr: func.isRequired,
    resetAgeVerificationFlag: func.isRequired,
    seoData: shape({
        seo_searchable: bool,
        page_title: string,
        keywords: string,
        meta_description: string,
        og: array,
    }).isRequired,
    urlParams: object.isRequired,
    isPlaEnabled: bool.isRequired,
    isPla: bool.isRequired,
    featureFlags: object.isRequired,
    presentation_family: string.isRequired,
    brand: shape({
        domain: string.isRequired,
    }).isRequired,
    isPassportBundleItem: bool.isRequired,
    client: object.isRequired, // Apollo Client
    addressSource: string,
    showLoadingMessage: bool,
    removeGCIData: func.isRequired,
    baseProductPartNumber: string,
    cartError: string,
    callClearErrors: func.isRequired,
    passportData: shape({
        passport_bundle: {
            pdpage_passport_bundle_title: string,
        },
        passport_up_sell_conditional_logic_at_entrance: shape({
            enable: bool,
            utm_param: string,
        }),
        passport_messaging: shape({
            enable_member_message: bool,
            member_message: string,
        }),
    }),
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    locationType: string.isRequired,
    currencyData: string.isRequired,
};

const mapStateToProps = (state) => ({
    brandId: appConfigSelectors.getCurrentBrandId(state),
    featureFlags: getFeatureFlags(state),
    brand: appConfigSelectors.getBrand(state),
    addressSource: getAddressSource(state),
    showLoadingMessage: getLoaderStatus(state),
    cartError: getCartError(state),
    passportData: getPassportData(state),
    locationType: getLocationType(state),
    currencyData: getCurrencyData(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        loadSr: shopRunnerActions.loadShopRunner,
        resetAgeVerificationFlag: setAgeVerifyFlagInvalid,
        removeGCIData: clearGCIData,
        callClearErrors: clearErrors,
    },
    dispatch,
);

const enhance = compose(
    trackPage(),
    withRouter,
    withApollo,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(GraphqlProductPageBuilder);
